import { Cookies } from '../../../../utility/cookies';
import { FAVORITE_RECIPE_COOKIE_NAME } from './cookieKeys';

const CACHE_TIME_DAYS = 365;

/** Stores favourite recipe as EXTERNAL IDs in cookie  */
const favouriteRecipesAnonymousCookie = {
    get: (): string[] => {
        const rawCookie = Cookies.read(FAVORITE_RECIPE_COOKIE_NAME);
        return (rawCookie && (JSON.parse(rawCookie) as string[])?.map((i) => i.toString())) || [];
    },

    add: (externalRecipeId: string): boolean => {
        const state = favouriteRecipesAnonymousCookie.get();
        if (state.includes(externalRecipeId)) {
            return false;
        }

        Cookies.create(
            FAVORITE_RECIPE_COOKIE_NAME,
            JSON.stringify([...state, externalRecipeId]),
            CACHE_TIME_DAYS,
        );
        return true;
    },

    remove: (externalRecipeId: string): boolean => {
        const state = favouriteRecipesAnonymousCookie.get();

        const newState = state.filter((item) => item !== externalRecipeId);

        Cookies.create(FAVORITE_RECIPE_COOKIE_NAME, JSON.stringify([...newState]), CACHE_TIME_DAYS);
        return true;
    },
};

export default favouriteRecipesAnonymousCookie;
